var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"baner"},[_c('div',{staticClass:"holdContent"},[_c('img',{attrs:{"src":_vm.production ? 
        _vm.path_prefix.slice(0, -1).concat(require('../../assets/images/baner.svg')):
        require('../../assets/images/baner.svg')}})])])}
var staticRenderFns = []

export { render, staticRenderFns }